/* eslint-disable react/prop-types */
import { Button, Spin, DatePicker, Switch } from 'antd';
import * as sortBy from 'lodash/sortBy';
import moment from 'moment';
import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import NotifyAlert from '../../components/Notify/NotifyAlert';
import NotifyError from '../../components/Notify/NotifyError';
import DirectDiscountApi from '../../functions/api/booking/DirectDiscountApi';
import CityApi from '../../functions/api/partner/CityApi';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import VehiclePartner from '../../functions/api/partner/VehiclePartner';
import VehicleApi from '../../functions/api/vehicle/VehicleApi';
import ConvertDirectDiscount from '../../functions/ConvertDirectDiscount';
import MyUtil from '../../functions/MyUtil';
import '../css/AddVehicle.css';

class FormAddDirectDiscount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      discount_value: '',
      max_value: '',
      city_id: '',
      vhc_id: '',
      part_id: '',
      vhc_part_id: '',
      active_at: new Date(),
      expire_at: this.addDays(new Date(), 7),
      vehicles: [],
      partners: [],
      cites: [],
      vehicle_type: [
        { type_id: 1, type_name: 'Oto' },
        { type_id: 2, type_name: 'Xe máy' },
      ],
      type_id: 1,
      vehicle_partner: false,
      is_active: 1,
      isEdit: false,
    };
  }

  componentDidMount = async () => {
    const { match } = this.props;
    if (match.params && match.path === '/direct-discount/edit/:discountId') {
      const { discountId } = match.params;
      const detail = await DirectDiscountApi.getById(discountId);

      let vhcPart = await VehiclePartner.getAllVehiclePartner({
        part_id: detail[0].part_id,
      });
      vhcPart = sortBy(vhcPart, ['vhc_part_name']);

      this.setState({ vehicle_partner: vhcPart, isEdit: true, ...detail[0] });
    }
  };

  componentWillMount = async () => {
    const { type_id } = this.state;

    let vehicles = await VehicleApi.getByOptions({ vhc_type_id: type_id });
    vehicles = sortBy(vehicles, ['vhc_slug']);

    let partners = await PartnerApi.getAll();
    partners = sortBy(partners, ['part_name']);

    let cities = await CityApi.getAll();
    cities = sortBy(cities, ['city_name_en']);

    this.setState({ vehicles, partners, cities });
  };

  addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  handleChangePromoActive = (date) => {
    this.setState({
      active_at: date,
    });
  };

  handleChangePromoExpire = (date) => {
    this.setState({
      expire_at: date,
    });
  };

  handleChange = async (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleChangeVehicle = async (event) => {
    await this.setState({ vhc_id: event.target.value });
  };

  handleChangePrice = (event) => {
    const { value } = event.target;
    const { name } = event.target;
    if (value) {
      const priceNumber = MyUtil.convertMoney(value);
      const priceStr = MyUtil.currencyFormat(priceNumber);

      this.setState({ [name]: priceStr });
    } else {
      this.setState({ [name]: '' });
    }
  };

  handleChangeActive = (checked) => {
    this.setState({
      is_active: checked,
    });
  };

  handleChangeShow = (checked) => {
    this.setState({
      is_show: checked,
    });
  };

  handleChangeCity = async (event) => {
    const city_id = event.target.value;
    const { type_id } = this.state;

    let partners = await PartnerApi.getPartnerByOptions({
      vhc_type_id: type_id,
      city_id,
    });
    partners = sortBy(partners, ['part_name']);

    await this.setState({ partners, city_id });
  };

  handleChangeType = async (event) => {
    const vhc_type_id = event.target.value;
    const { city_id } = this.state;

    let partners = await PartnerApi.getPartnerByOptions({
      vhc_type_id,
      city_id,
    });
    partners = sortBy(partners, ['part_name']);

    let vehicles = await VehicleApi.getByOptions({ vhc_type_id });
    vehicles = sortBy(vehicles, ['vhc_slug']);

    await this.setState({ partners, vehicles, type_id: vhc_type_id });
  };

  handleChangePartner = async (event) => {
    const vhcPartId = event.target.value;

    let vehiclePartner = await VehiclePartner.getAllVehiclePartner({
      part_id: vhcPartId,
    });
    vehiclePartner = sortBy(vehiclePartner, ['vhc_part_name']);

    await this.setState({
      part_id: vhcPartId,
      vehicle_partner: vehiclePartner,
    });
  };

  clearForm = () => {
    this.setState({
      id: 0,
      discount_value: '',
      max_value: '',
      city_id: '',
      type_id: 1,
      vhc_id: '',
      part_id: '',
      vhc_part_id: '',
      active_at: '',
      expire_at: '',
      is_active: 1,
      is_show: 1,
      isEdit: false,
    });
  };

  handleCreate = async () => {
    const { check } = ConvertDirectDiscount.handleCheck(this.state);
    const { isEdit } = this.state;
    if (!check) {
      const directDiscount = ConvertDirectDiscount.handleNew(this.state);
      let result = '';
      if (isEdit) {
        result = await DirectDiscountApi.update(
          directDiscount.id,
          directDiscount
        );
      } else result = await DirectDiscountApi.create(directDiscount);
      console.log('result ', result);
      if (result && !result.message) {
        let message = '';
        if (isEdit) message = 'Sửa khuyến mại thành công!';
        else message = 'Thêm khuyến mại thành công';

        NotifyAlert('Thành công', message);
        if (!isEdit) this.clearForm();
      } else {
        NotifyError('Lỗi', result.message);
      }
    } else {
      NotifyAlert('Thông báo', `Dữ liệu bạn nhập bị thiếu. Hãy kiểm tra lại.`);
    }
  };

  render() {
    const {
      discount_value,
      max_value,
      city_id,
      type_id,
      vhc_id,
      part_id,
      vhc_part_id,
      active_at,
      expire_at,
      vehicles,
      partners,
      vehicle_type,
      cities,
      vehicle_partner,
      is_active,
      isEdit,
    } = this.state;

    const { discount_id } = this.props.match.params;

    if (discount_id && !vehicle_partner) {
      return <Spin />;
    }

    return (
      <div className="content">
        <h1>{isEdit ? 'Sửa giảm giá trực tiếp' : 'Thêm giảm giá trực tiếp'}</h1>

        <div>
          <Row className="row-form">
            <div className="row-child row-child-small">
              <div className="title-content-page">Giá trị giảm</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChangePrice}
                name="discount_value"
                value={discount_value}
              />
              <span style={{ fontSize: '12px' }}>
                Nhỏ hơn 100 là giảm theo %; Lớn hơn 100 là giảm theo vnđ
              </span>
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page">Giảm tối đa</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChangePrice}
                name="max_value"
                defaultValue={max_value}
              />
              <span style={{ fontSize: '12px' }}>
                Số tiền tối đa được giảm khi giá trị giảm là %
              </span>
            </div>
          </Row>

          <Row className="row-form">
            <div className="row-child row-child-small">
              <div className="title-content-page">Áp dụng cho thành phố</div>
              <select
                id="select-vehicle"
                className="select-vehicle input-normal full-width"
                onChange={this.handleChangeCity}
                name="city_id"
                value={city_id || 0}
                required
              >
                <option value="0">Tất cả các thành phố</option>
                {cities &&
                  cities.length > 0 &&
                  cities.map((city) => (
                    <option key={city.city_id} value={city.city_id}>
                      {city.city_name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="row-child row-child-small">
              <div className="title-content-page">Áp dụng cho loại xe</div>
              <select
                id="select-vehicle"
                className="select-vehicle input-normal full-width"
                name="type_id"
                onChange={this.handleChangeType}
                value={type_id || 0}
                required
              >
                <option value="0">Cả Oto và Xe máy</option>
                {vehicle_type &&
                  vehicle_type.length > 0 &&
                  vehicle_type.map((type) => (
                    <option key={type.type_id} value={type.type_id}>
                      {type.type_name}
                    </option>
                  ))}
              </select>
            </div>
          </Row>

          <Row>
            <div className="row-child row-child-small">
              <div className="title-content-page">Áp dụng cho dòng xe</div>
              <select
                id="select-vehicle"
                className="select-vehicle input-normal full-width"
                name="vhc_id"
                onChange={this.handleChangeVehicle}
                value={vhc_id || 0}
                required
              >
                <option value="0">Tất cả dòng xe</option>
                {vehicles &&
                  vehicles.length > 0 &&
                  vehicles.map((vehicle) => (
                    <option key={vehicle.vhc_id} value={vehicle.vhc_id}>
                      {MyUtil.makeTitle(vehicle.vhc_slug)}
                    </option>
                  ))}
              </select>
            </div>
            <div className="row-child row-child-small">
              <div className="title-content-page">Áp dụng cho đối tác</div>
              <select
                id="select-partner"
                className="select-partner input-normal full-width"
                name="part_id"
                onChange={this.handleChangePartner}
                defaultValue={part_id || 0}
                required
              >
                <option value="0">Tất cả đối tác</option>
                {partners &&
                  partners.length > 0 &&
                  partners.map((partner) => (
                    <option key={partner.part_id} value={partner.part_id}>
                      {partner.part_name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="row-child row-child-small">
              <div className="title-content-page">
                Áp dụng cho xe cụ thể của đối tác
              </div>
              <select
                id="select-vehicle-partner"
                className="select-vehicle-partner input-normal full-width"
                name="vhc_part_id"
                onChange={this.handleChange}
                defaultValue={vhc_part_id || 0}
                required
              >
                <option value="0">Tất cả xe của đối tác</option>
                {vehicle_partner &&
                  vehicle_partner.length > 0 &&
                  vehicle_partner.map((vehicle) => (
                    <option
                      key={vehicle.vhc_part_id}
                      value={vehicle.vhc_part_id}
                    >
                      {vehicle.vhc_part_name}
                    </option>
                  ))}
              </select>
            </div>
          </Row>

          <Row className="row-form">
            <div className="row-child row-child-small">
              <div className="title-content-page">Bắt đầu</div>
              <DatePicker
                defaultValue={moment(active_at)}
                format="HH:mm DD/MM/YYYY"
                showTime={{
                  format: 'HH:mm',
                  minuteStep: 10,
                }}
                onChange={this.handleChangePromoActive}
                allowClear
              />
            </div>
            <div className="row-child row-child-small">
              <div className="title-content-page">Kết thúc</div>
              <DatePicker
                defaultValue={moment(expire_at)}
                format="HH:mm DD/MM/YYYY"
                showTime={{ format: 'HH:mm', minuteStep: 10 }}
                onChange={this.handleChangePromoExpire}
                allowClear
              />
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page ">Kích hoạt khuyến mại</div>
              <label className="lable-option" style={{ margin: '0px' }}>
                <Switch
                  onChange={this.handleChangeActive}
                  checked={!!is_active}
                  id="normal-switch"
                />
              </label>
            </div>
          </Row>
        </div>

        <Row>
          <Button className="mr-3" type="primary" onClick={this.handleCreate}>
            Lưu thay đổi
          </Button>

          <Button onClick={() => this.props.history.push('/direct-discount')}>
            Quay lại
          </Button>
        </Row>
      </div>
    );
  }
}

export default FormAddDirectDiscount;
